export const variables = {
  SWEEPSTAKES: 'sweepstakes',
  TEAM: 'team',
  INDIVIDUAL: 'individual',
  STEP: 'step',
  WEIGHT_LOSS: 'weightLoss',
  JACKPOT: 'jackpot'
}

export const INDIVIDUAL_TEAM_TEXT = getIndividualTeamText();

function getIndividualTeamText() {
  try {
    // eslint-disable-next-line no-undef
    return individualTeamText; // saved on templates/base_tmpl.html
  } catch (error) {
    return '';
  }
}
